import React from "react";
import styled from "styled-components";
import { CustomComponentCustomFormField } from "../../../../../../amorg-common";
import { tablet } from "../../../../../../designSystem/BreakPoints";
import { colors } from "../../../../../../designSystem/colors/color";
import { Flex } from "../../../../../../designSystem/compositeComponents/FlexHelpers";
import { DeviceView } from "../../../../../../designSystem/DeviceView";
import { CustomFormFieldHeader } from "../../../../[parm]/_components/CustomFormFieldHeader";
import { CustomFormFieldCard, CustomFormFieldCardColored } from "../../../../[parm]/_components/CustomFormFieldCard";

type RiskAssessmentHelperProps = 
{
    riskAssessmentField:CustomComponentCustomFormField,
    sumElements:{ text:string, value:number }[],
    factorElements: { text:string, value:number }[],
    document?:string,
    
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function RiskAssessmentHelper(props:RiskAssessmentHelperProps):JSX.Element
{


    const factorElementTotal = props.factorElements.reduce((accumulator, factor) => {
        return accumulator * factor.value;
      }, 1);
    const newRiskAssessmentValue = props.sumElements.reduce((acc, element) => acc + element.value, 0) * factorElementTotal;

    const getClassName = (points: number) => {
        let className = "risk-div";
    
        switch (points) {
            case 1:
                if (newRiskAssessmentValue < 10) {
                    className += " active";
                }
                break;
            case 2:
                if (newRiskAssessmentValue >= 10 && newRiskAssessmentValue < 25) {
                    className += " active";
                } 
                break;
            case 3:
                if (newRiskAssessmentValue >= 25 && newRiskAssessmentValue < 50) {
                    className += " active";
                }
                break;
            case 4:
                if (newRiskAssessmentValue >= 50) {
                    className += " active";
                }
                break;
            case 40:
                className += " active";
                break;
            default:
                break;
        }
    
        return className;
    };

    const RiskBarContent = props.document === "kim1" ? RiskBarContent_kim1 : props.document === "kim2" ? RiskBarContent_kim2 : RiskBarContent_kim3;

    return (
        <section>
            <CustomFormFieldHeader field={props.riskAssessmentField} />
            <CustomFormFieldCard paddingTop={16}>
                <Flex flexDirection="column" gap={16}>
                <CalculaterModel sumElements={props.sumElements} factorElements={props.factorElements} />
                
                <CustomFormFieldCardColored variant='attention'>
                    Med støtte af beregnede point og tabellen nedenfor er det muligt at foretage en grov vurdering til udvælgelse af handleplan for forbedringer.
                    Vær OBS på, at i takt med antallet af vurderingspoint stiger, øges også risikoen for overbelastning af muskler, sener, led og knogler.
                    Grænserne mellem risikoområderne er flydende på grund af individuel arbejdsteknik og præstationsevne.
                </CustomFormFieldCardColored>
            
                <DeviceView
                    desktop={
                        <RiskBarHeader>
                            <div></div>
                            <div>Risikograd</div>
                            <div>Risikopoint</div>
                            <div>Beskrivelse</div>
                        </RiskBarHeader>
                    } />
                
                <DeviceView
                    mobile={
                        <RiskBarContainer>
                            <RiskBar>
                                <RiskBarPointer points={newRiskAssessmentValue}><span>{newRiskAssessmentValue.toFixed(0)}</span></RiskBarPointer>
                            </RiskBar>
                            <RiskContent>
                            {RiskBarContent.map((risk, index) => (
                                <RiskRow key={index} className={getClassName(risk.value)}>
                                    <RiskArea>
                                        <b>Risikograd:</b><br />
                                        {risk.area}</RiskArea>
                                    <RiskPoints>
                                        <b>Risikopoint:</b><br />
                                        {risk.points}</RiskPoints>
                                    <RiskDescription>
                                        <b>Beskrivelse:</b><br />
                                        <div dangerouslySetInnerHTML={{__html: risk.description}}></div>
                                    </RiskDescription>
                                </RiskRow>      
                            ))}
                            </RiskContent> 
                        </RiskBarContainer>
                    }
                    desktop={
                        <RiskBarContainer>
                            <RiskBar>
                                <RiskBarPointer points={newRiskAssessmentValue}><span>{newRiskAssessmentValue.toFixed(0)}</span></RiskBarPointer>
                            </RiskBar>
                            <RiskContent>

                            {RiskBarContent.map((risk, index) => (
                                <RiskRow key={index} className={getClassName(risk.value)}>
                                    <RiskArea></RiskArea>
                                    <RiskPoints>{risk.points}</RiskPoints>
                                    <RiskDescription>
                                        <div dangerouslySetInnerHTML={{__html: risk.description}}></div>
                                    </RiskDescription>
                                </RiskRow>      
                            ))}
                            </RiskContent> 
                        </RiskBarContainer>
                    } />
                    </Flex>
            </CustomFormFieldCard>
        </section>
    );
}

type CalculaterModelProps = {
    sumElements:{ text:string, value:number }[],
    factorElements: { text:string, value:number }[],
}

function CalculaterModel(props:CalculaterModelProps):JSX.Element{

    const [sumTotal, setsumTotal] = React.useState<number>(0);
    const [riskAssessment, setRiskAssessment] = React.useState<number>(0);

    React.useEffect(() => {
        const factorTotal = props.factorElements.reduce((accumulator, factor) => {
            return accumulator * factor.value;
          }, 1);

        const sum = props.sumElements.reduce((acc, element) => acc + element.value, 0);
        setsumTotal(sum);

        const calculatedRisk = factorTotal * sum;
        setRiskAssessment(Number(calculatedRisk.toFixed(0)));

        // setRiskAssessment(factorTotal * sum);

    }, [props.sumElements, props.factorElements]);


    return (
        <CalculaterModelContainer>
            
            {props.factorElements.map((factorElement, index) => (
                <Flex key={index}>
                    <BoxSingle><Flex flexDirection="row" justifyContent="space-between">{factorElement.text}<span>{factorElement.value || 0}</span></Flex></BoxSingle>
                    <BoxCalc>X</BoxCalc>
                </Flex>
            ))}
            <BoxMulti>
                <div>Vurderingspoint for:</div>
                {props.sumElements.map((element, index) => (
                    <Flex key={index} flexDirection="row" justifyContent="space-between">
                        <span dangerouslySetInnerHTML={{__html: element.text}}></span>
                        <span>{element.value || 0}</span>
                    </Flex>
                ))}
                <Flex flexDirection="row" justifyContent="space-between">Total<span>{sumTotal}</span></Flex>
            </BoxMulti>
            <Flex flexDirection="row">
                <BoxCalc>=</BoxCalc>
                <BoxSingleResult><Flex flexDirection="row" justifyContent="space-between">Risikopoint <span>{riskAssessment}</span></Flex></BoxSingleResult>
            </Flex>
        </CalculaterModelContainer>
    )
}

const CalculaterModelContainer = styled.div`
    display: grid;
    flex-direction: row;
    grid-template-columns: 25% 25% 25% 25%;
        
    @media only screen and (max-width: ${tablet}px){
        grid-template-columns: 100%;
        flex-direction: column;
        
    }
`
const BoxSingle = styled.div`
    align-self: end;
    border: 1px solid ${colors.table.border};
    padding: 8px;
    flex-grow: 1;

    @media only screen and(max-width: ${tablet}px){
        align-self: auto;
        padding: 8px 16px;
    }
`

const BoxSingleResult = styled.div`
    align-self: end;
    background: ${colors.background.beige};
    padding: 8px;
    flex-grow: 1;

    @media only screen and(max-width: ${tablet}px){
        align-self: auto;
        padding: 8px 16px;
    }

`

const BoxMulti = styled.div`
    align-self: end;
    border: 1px solid ${colors.table.border};
    padding: 8px;

    
    & div:not(:last-child) {
        border-bottom: 1px solid ${colors.table.border};
        padding: 8px;
    }

    & div:last-child {
        padding: 8px 8px 0 8px;
    }

    @media only screen and (max-width: ${tablet}px){
        align-self: auto;
    }
`

const BoxCalc = styled.div`
    align-self: end;
    display:flex;
    justify-content: center;
    padding: 8px;

    @media only screen and (max-width: ${tablet}px){
        justify-content: end;
        padding: 8px 16px;
    }

`;

const RiskBarHeader = styled.div`
    background: ${props => props.theme.colors.customForm.answer.formFieldCard.cardHeader.background};
    color:${props => props.theme.colors.customForm.answer.formFieldCard.cardHeader.text};
    display: grid;
    grid-template-columns: 100px 120px 120px 1fr;
    font-weight: 500;
    padding: 8px;
    margin-bottom: 4px;
    & div{
        justify-self: start;
    }

    @media only screen and(max-width: ${tablet}px){
        grid-template-columns: 100px 100px 1fr;
    }

    @media only screen and(max-width: ${tablet}px){

        grid-template-columns: 50% 50%;
        grid-template-rows: 1fr 1fr;
        padding: 8px 0;
    }


`

const RiskBarContainer = styled.div`
    display: grid;
    grid-template-areas: "RiskBar RiskContent";

    @media only screen and(max-width: ${tablet}px){
        
    }
`
const RiskContent = styled.div`
    grid-area: RiskContent;
    
    & .risk-div.active{
        background : ${props => props.theme.colors.background.gray};
    }
`

const RiskBar = styled.div`
    grid-area: RiskBar;
    background: rgb(204,51,17);
    background: linear-gradient(0deg, rgba(204,51,17,1) 0%, rgba(204,51,17,1) 10%, rgba(238,221,119,1) 45%, rgba(238,221,119,1) 55%, rgba(17,119,51,1) 90%, rgba(17,119,51,1) 100%);
    height: 100%;
    width: 100px;

    @media only screen and(max-width: ${tablet}px){
        margin-right: 10px;
        width: 50px;
    }
`



const RiskBarPointer = styled.div<{points:number}>`

    ${props => {
        if (props.points >= 50 && props.points <= 350) {
            const relativePosition = 1 - (props.points - 50) / (350 - 50);
            return `top: calc(100% - ${relativePosition * 25}%);`;
        } else if (props.points >= 25 && props.points < 50) {
            const relativePosition = 1 - (props.points - 25) / (50 - 25);
            return `top: calc(75% - ${relativePosition * 25}%);`;
        } else if (props.points >= 10 && props.points < 25) {
            const relativePosition = 1 - (props.points - 10) / (25 - 10);
            return `top: calc(50% - ${relativePosition * 25}%);`;
        } else if (props.points >= 1 && props.points < 10) {
            const relativePosition = 1 - (props.points - 1) / (10 - 1);
            return `top: calc(25% - ${relativePosition * 25}%);`;
        } else {
            return `top: 100%;`;
        }
    }}
    
    width:100%;
    border-bottom:2px solid black;
    position:relative;
    transition: all 0.5s ease;

    & span{
        position:absolute;
        top: -16px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 24px;
        font-weight: bold;
        color:white;
    }
`

const RiskRow = styled.div`
    display: grid;
    grid-template-columns: 120px 120px 1fr;
    grid-template-areas: "RiskArea RiskPoints RiskDescription";

    border-bottom: 1px solid ${colors.table.border};
    min-height:100px;

    & b{
        font-weight: 500;
    }

    @media only screen and (max-width: ${tablet}px){

        grid-template-columns: 50% 50%;
        grid-template-areas: 
        "RiskArea RiskPoints"
        "RiskDescription RiskDescription";
        padding: 8px 0;
    }
`

const RiskArea = styled.div`
    align-self: center;
    justify-self: center;
    grid-area: RiskArea;

    @media only screen and (max-width: ${tablet}px){

        justify-self: start;
    }
`

const RiskPoints = styled.div`
    align-self: center;
    justify-self: center;
    grid-area: RiskPoints;

    @media only screen and (max-width: ${tablet}px){
        justify-self: start;
    }
`

    
const RiskDescription = styled.div`
    align-self: center;
    grid-area: RiskDescription;
`

type RiskData = {
    area:string,
    points:string,
    description:string,
    value:number
}


const RiskBarContent_kim1:RiskData[] = [
    {
        area: "1",
        points: "Under 10",
        description: "<b>Lav belastningssituation</b><br />fysisk overbelastning er usandsynlig.",
        value: 1
    },
    {
        area: "2",
        points: "10 < 25",
        description: `<b>Øget belastningssituation</b><br />Fysisk overbelastning er mulig for personer med lavere fysisk kapacitet. For
denne gruppe er det fordelagtigt at ændre arbejdspladsens design – dvs. vægt af emner, frekvens
af løft, varighed af løftearbejde, pladsforhold og brug af egnede tekniske hjælpemidler`,
        value: 2
    },
    {
        area: "3",
        points: "25 < 50",
        description: `<b>Markant øget belastningssituation</b><br />Fysisk overbelastning er mulig. Et nyt design af arbejdspladsen
anbefales – dvs. vægt af emner, frekvens af løft, varighed af løftearbejde, pladsforhold og brug af
egnede tekniske hjælpemidler.`,
    value: 3
    },
    {
        area: "4",
        points: "Over 50",
        description: `<b>Høj belastningssituation</b><br />Fysisk overbelastning er sandsynlig. Arbejdspladsens design skal ændres
– dvs. vægt af emner, frekvens af løft, varighed af løftearbejde, pladsforhold og brug af egnede
tekniske hjælpemidler`,
    value: 4
    }
]

const RiskBarContent_kim2:RiskData[] = [
    {
        area: "1",
        points: "Under 10",
        description: "<b>Lav belastningssituation</b><br />fysisk overbelastning er usandsynlig.",
        value: 1
    },
    {
        area: "2",
        points: "10 < 25",
        description: `<b>Øget belastningssituation</b><br />Fysisk overbelastning er mulig for personer med lavere fysisk kapacitet. For
denne gruppe er det fordelagtigt at ændre arbejdspladsens design.`,
        value: 2
    },
    {
        area: "3",
        points: "25 < 50",
        description: `<b>Markant øget belastningssituation</b><br />Fysisk overbelastning er mulig også for personer med normal kapacitet. Et nyt design af arbejdspladsen
anbefales.`,
    value: 3
    },
    {
        area: "4",
        points: "Over 50",
        description: `<b>Høj belastningssituation</b><br />Fysisk overbelastning er sandsynlig. Arbejdspladsens design skal ændres / ny udformning af arbejdspladsen er nødvendig.`,
    value: 4
    }
]

const RiskBarContent_kim3:RiskData[] = [
    {
        area: "1",
        points: "Under 10",
        description: "<b>Lav belastningssituation</b><br />fysisk overbelastning er usandsynlig.",
        value: 1
    },
    {
        area: "2",
        points: "10 < 25",
        description: `<b>Øget belastningssituation</b><br />Fysisk overbelastning er mulig for personer med lavere fysisk kapacitet. For
denne gruppe er det fordelagtigt at ændre arbejdspladsens design – dvs. vægt af emner, frekvens
af løft, varighed af løftearbejde, pladsforhold og brug af egnede tekniske hjælpemidler`,
        value: 2
    },
    {
        area: "3",
        points: "25 < 50",
        description: `<b>Markant øget belastningssituation</b><br />Fysisk overbelastning er mulig også for personer med normal kapacitet. Et nyt design af arbejdspladsen
anbefales.`,
    value: 3
    },
    {
        area: "4",
        points: "Over 50",
        description: `<b>Høj belastningssituation</b><br />Fysisk overbelastning er sandsynlig. Arbejdspladsens design skal ændres / ny udfordring af arbejdspladsen er nødvendig.`,
    value: 4
    }
]